import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol viewBox=\"0 0 11 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back\">\n<path d=\"M10.9998 5.66664L3.27592 5.66665L6.27592 8.66664L5.33311 9.60945L0.723633 4.99998L5.33311 0.390503L6.27592 1.33331L3.27592 4.33331L10.9998 4.33331V5.66664Z\" fill=\"#232323\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol